import React from "react";
import clsx from "clsx";

interface SectionInfoHeaderProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  color?: string; // permite color custom (por defecto usa primary)
}

const SectionInfoHeader: React.FC<SectionInfoHeaderProps> = ({
  icon,
  title,
  description,
  color = "bg-primary",
}) => {
  return (
    <div className="mb-2 flex items-start gap-2 pb-3 sm:items-center sm:gap-3">
      {/* Icon wrapper */}
      <div
        className={clsx(
          "flex items-center justify-center rounded-full text-white dark:bg-blue-600",
          color,
          "h-8 w-8 sm:h-10 sm:w-10"
        )}
      >
        {icon}
      </div>

      {/* Texto */}
      <div>
        <h2 className="text-sm font-bold text-slate-800 dark:text-white sm:text-base">
          {title}
        </h2>
        <p className="text-[10px] text-slate-500 dark:text-slate-400 sm:text-xs">
          {description}
        </p>
      </div>
    </div>
  );
};

export default SectionInfoHeader;
